import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsExclamationTriangle, BsClock, BsCheckCircle, BsArchive, BsBarChart } from 'react-icons/bs';
import styled from 'styled-components';

const CounterCard = styled.div`
  border: 1px solid ${(props) => props.borderColor || '#c2d2e9'};
  border-left: 5px solid ${(props) => props.borderColor || '#c2d2e9'};
  border-radius: 8px;
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: default;
  min-height: 120px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    margin-bottom: 15px;
    min-height: 100px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  }

  .counter-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .counter-value {
    font-size: 48px;
    font-weight: bold;
    color: ${(props) => props.textColor || '#1976d2'};
    margin-bottom: 5px;
    line-height: 1;

    @media (max-width: 768px) {
      font-size: 36px;
    }
  }

  .counter-label {
    font-size: 16px;
    font-weight: 600;
    color: ${(props) => props.textColor || '#1976d2'};
    margin: 0;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .counter-icon {
    font-size: 60px;
    color: ${(props) => props.iconColor || '#42a5f5'};
    opacity: 0.8;

    @media (max-width: 768px) {
      font-size: 50px;
    }
  }
`;

const StatusCounters = ({ stats }) => {
  const totalConfig = {
    status: 'TOTAL',
    label: 'Total de Incidentes',
    value: stats.total || 0,
    borderColor: '#5ca1d9',
    textColor: '#5ca1d9',
    iconColor: '#5ca1d9',
    icon: <BsBarChart />
  };
  const statusConfig = [
    {
      status: 'ABERTO',
      label: 'Abertos',
      value: stats.open || 0,
      borderColor: '#b91b2a',
      textColor: '#b91b2a',
      iconColor: '#b91b2a',
      icon: <BsExclamationTriangle />
    },
    {
      status: 'EM_ANALISE',
      label: 'Em Análise',
      value: stats.inProgress || 0,
      borderColor: '#d1a86b',
      textColor: '#d1a86b',
      iconColor: '#d1a86b',
      icon: <BsClock />
    },
    {
      status: 'CONCLUIDO',
      label: 'Concluídos',
      value: stats.completed || 0,
      borderColor: '#77c779',
      textColor: '#77c779',
      iconColor: '#77c779',
      icon: <BsCheckCircle />
    },
    {
      status: 'ARQUIVADO',
      label: 'Arquivados',
      value: stats.archived || 0,
      borderColor: '#ac53bb',
      textColor: '#ac53bb',
      iconColor: '#ac53bb',
      icon: <BsArchive />
    }
  ];

  return (
    <Row>
      {/* Total */}
      <Col style={{ width: '20%', flex: '0 0 20%' }}>
        <CounterCard
          borderColor={totalConfig.borderColor}
          textColor={totalConfig.textColor}
          iconColor={totalConfig.iconColor}
          id={`status-counter-${totalConfig.status.toLowerCase()}`}
        >
          <div className='counter-content'>
            <div className='counter-value'>{totalConfig.value}</div>
            <p className='counter-label'>{totalConfig.label}</p>
          </div>
          <div className='counter-icon'>
            {totalConfig.icon}
          </div>
        </CounterCard>
      </Col>
      {statusConfig.map((config, index) => (
        <Col key={config.status} style={{ width: '20%', flex: '0 0 20%' }} >
          <CounterCard
            borderColor={config.borderColor}
            textColor={config.textColor}
            iconColor={config.iconColor}
            id={`status-counter-${config.status.toLowerCase()}`}
          >
            <div className='counter-content'>
              <div className='counter-value'>{config.value}</div>
              <p className='counter-label'>{config.label}</p>
            </div>
            <div className='counter-icon'>
              {config.icon}
            </div>
          </CounterCard>
        </Col>
      ))}
    </Row>
  );
};

export default StatusCounters;
